import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { priceFormatter, parsePrice } from '../../SendToAgenciesSummaryView.constants';
import { useFetchJaneByIdDataContext } from '../../DirectRequests/FetchJaneByJaneId.data.context';
import { ShiftPay } from '../ShiftPay';

function InternalPayComponent() {
  const { data: shiftModalData } = useShiftModalDataContext();
  const order = shiftModalData!.order;

  const { data } = useFetchJaneByIdDataContext();

  const janeEstimatedPayout = data?.janeEstimatedPayout || '$0';
  const janeEstimatedTotalPayout = priceFormatter.format(
    order.totalDuration! * parsePrice(janeEstimatedPayout),
  );

  return (
    <ShiftPay
      estimatedHourlyPay={janeEstimatedPayout}
      estimatedTotalPay={janeEstimatedTotalPayout}
    />
  );
}

export function InternalPay() {
  return <InternalPayComponent />;
}
